// extracted by mini-css-extract-plugin
export default {"pdf-editor-margin":"20","pdf-page-height":"890.9850566929","pdf-page-width":"651.8961771654"};